module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail/modal-mnn/modal-mnn.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail/modal-mnn/modal-mnn.component.sass
// module chunks = main